/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponWithCode } from './BaseCouponWithCode';
import { CoursePrice } from './CoursePrice';
const CouponWithCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('course')],
    ['coursePrice', CoursePrice, 'course_price'],
]), BaseCouponWithCode);
export class CouponWithCode extends BaseCouponWithCode {
    static decode(input) {
        return CouponWithCodeParser.decode(input).map(res => new CouponWithCode(res));
    }
    static unsafeDecode(input) {
        return CouponWithCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CouponWithCodeParser.encode(data);
    }
    static schema() {
        return CouponWithCodeParser.schema();
    }
}
